import React from 'react'
import LoadingOverlay from 'react-loading-overlay';
import PropagateLoader from "react-spinners/PropagateLoader";
import routes from 'routes';
import SettingsService from 'services/api/Setting';

class SettingsLoader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        // localStorage.setItem("menuOrder", "Schedule,Project,Run,Chat,Storage,Admin,Model Space");
        if (localStorage.getItem("role") === "PLATFORM_ADMIN") {
            this.props.history.push('/accounts');
        } else {
            this.getMenuList();
        }
        document.body.classList.add("tenant-page");
        var elements = document.getElementsByClassName('full-page section-image');
        for (var index = 0; index < elements.length; index++) {
            elements[index].classList.add("df-bg-white");
        }

    }

    RedirecttoHomePage = (customMenuData) => {
        let menuOrderList = JSON.parse(localStorage.getItem("menuOrder"));
        if (menuOrderList !== null && menuOrderList.length !== 0) {
            let activePathList = routes.filter(item => item.name === menuOrderList[0].displayName)
            if (activePathList !== undefined && activePathList.length !== 0) {
                let routePath = activePathList[0];
                if (routePath.hasOwnProperty("collapse")) {
                    let viewsPath = routePath.views[0];
                    if (viewsPath.hasOwnProperty("collapse")) {
                        viewsPath = routePath.views[0].views[0].path;

                        localStorage.setItem("landingPath", viewsPath);

                    }
                    else {
                        viewsPath = routePath.views[0].path;
                        localStorage.setItem("landingPath", viewsPath);
                    }
                } else {
                    let viewsPath = routePath.path;
                    localStorage.setItem("landingPath", viewsPath)
                }
            }
            setTimeout(() => {
                if (localStorage.getItem("Uid") !== null) {
                    if (localStorage.getItem("role") === "PLATFORM_ADMIN") {
                        this.props.history.push('/accounts');
                    } else {
                        let navigatePath = localStorage.getItem("landingPath");
                        this.props.history.push("/" + navigatePath);
                    }
                }
            }, 3000);
        }
    }
    getMenuList = () => {
        SettingsService.getMenuList()
            .then((response) => {
                if (response.status === 'SUCCESS') {
                    let menuData = response.reorderMenus;
                    let customMenuData = response.customMenus;
                    localStorage.setItem("menuOrder", JSON.stringify(menuData));      
                    this.RedirecttoHomePage(customMenuData);
                }else{
                    if (localStorage.getItem("Uid") !== null) {
                        if (localStorage.getItem("role") === "PLATFORM_ADMIN") {
                            this.props.history.push('/accounts');
                        } else {
                             let navigatePath = localStorage.getItem("landingPath");
                            this.props.history.push("/" + navigatePath);
                        }
                    }
                }
            })
    }

    render() {
        return (<div className="content centerLoader">
            <LoadingOverlay
                active={true}
                spinner={<PropagateLoader
                    height={35}
                    width={5}
                    radius={2}
                    margin={2}
                    color={"#007bff"}
                />}
            ></LoadingOverlay></div>)
    }
}

export default SettingsLoader;